import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DropdownMenuSeparator } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownSeparator } from './separator.vanilla.mjs';

const DropdownSeparator = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = classNames(dropdownSeparator, classNameFromProps);
  return /* @__PURE__ */ jsx(
    DropdownMenuSeparator,
    {
      "data-scope": "dropdown",
      "data-part": "separator",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});

export { DropdownSeparator };
//# sourceMappingURL=Separator.mjs.map
